import { BusinessVertical } from "../types/featureAccess";

/**
 * Business verticals that may keep clinical records (Medical Charts, SOAP
 * notes) and collect clinical-only client fields such as date of birth.
 *
 * Mirrors the backend's `clinical_enabled_for` allow-list. Forms & Waivers
 * themselves are open to EVERY vertical — clinical records are the carve-out,
 * so this list must stay narrower than the full `BusinessVertical` union.
 *
 * Note: this is a UX affordance, not the security boundary. The backend still
 * gates the underlying PHI workflows and flips the `/access` section
 * permissions to `available: false` for salons that don't qualify.
 */
export const CLINICAL_VERTICALS: readonly BusinessVertical[] = [
  "aesthetician",
  "med_spa",
];

/** True when the salon's vertical is allowed to keep clinical records. */
export function isClinicalVertical(
  businessVertical: BusinessVertical | null | undefined,
): boolean {
  return !!businessVertical && CLINICAL_VERTICALS.includes(businessVertical);
}
